<template>
  <div>
    <!-- Map Section -->
    <section class="tw-relative tw-h-[60vh] tw-w-full tw-overflow-hidden lg:tw-h-[80vh]">
      <neuron-google-map-v2
        v-if="allMaps.length"
        v-model:markers="allMaps"
        :center="defaultCenter"
        :markerImg="markerImage"
        class="tw-absolute tw-inset-0 tw-h-full tw-w-full"
      />
    </section>

    <!-- Form Section -->
    <section class="tw-relative tw-z-50 tw-mt-8 tw-px-4 tw-pb-12 md:tw--mt-12">
      <div
        class="tw-mx-auto tw-max-w-2xl tw-bg-white tw-p-6 tw-shadow-lg md:tw-p-10"
        :class="`tw-bg-[var(--c-${vars.backgroundColor})]`"
      >
        <h2 v-if="vars.titleText" class="tw-mb-8 tw-text-center tw-text-[var(--c-primary)]">
          {{ vars.titleText }}
        </h2>
        <library-form
          v-if="form"
          :form="form"
          version="v2"
          :component="component"
          :is-form-name-visible="vars.isFormNameVisibleBool"
        />
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import NeuronGoogleMapV2 from '~/components/common/NeuronGoogleMapV2.vue';

export default defineNuxtComponent({
  name: 'BranchesContact',
  mixins: [ComponentMixin],
  components: { NeuronGoogleMapV2 },

  data() {
    return {
      form: null,
    };
  },

  created() {
    this.form = this.parseFormV2(this.vars.contactForm);
  },

  computed: {
    allMaps() {
      const locations = this.groupedVariables?.locations || [];
      return Array.isArray(locations) ? locations : [];
    },

    // Tüm marker’ların enlem/boylam ortalamasını hesaplayıp merkezi belirliyoruz
    defaultCenter() {
      if (this.allMaps.length > 0) {
        const sum = this.allMaps.reduce(
          (acc, loc) => ({
            lat: acc.lat + (loc.lat || 0),
            lng: acc.lng + (loc.lng || 0),
          }),
          { lat: 0, lng: 0 }
        );
        return {
          lat: sum.lat / this.allMaps.length,
          lng: sum.lng / this.allMaps.length,
        };
      }
      // Eğer hiç marker yoksa (güvenlik için) 0,0 dönebiliriz
      return { lat: 0, lng: 0 };
    },

    markerImage() {
      return this.allMaps.length > 0 && this.allMaps[0].marker
        ? this.allMaps[0].marker
        : '';
    },
  },

  watch: {
    'vars.contactForm': {
      handler(newForm) {
        if (newForm) {
          this.form = this.parseFormV2(newForm);
        }
      },
      deep: true,
    },
  },
});
</script>
